<div class="container-vertical">
  <div class="process-header">
    @if (description && description !== '-') {
      <p class="title">{{ description }}</p>
    }
    <button class="btn-logs-toggle" type="button" [class.active]="isLogsOpen" (click)="isLogsOpen = !isLogsOpen">
      <span class="logs-dot"></span>
      <span>Logs</span>
      <i class="fa logs-toggle-icon" [class.fa-chevron-left]="isLogsOpen" [class.fa-chevron-right]="!isLogsOpen"></i>
    </button>
  </div>

  @if (help?.trim()) {
    <div class="process-description">
      <span
        class="desc-text"
        [class.expanded]="isHelpShown"
        [innerHTML]="isHelpShown ? help : help.substr(0, 200)"></span>
      @if (!isHelpShown && help.length > 200) {
        <span class="help-more" (click)="isHelpShown = true"> (...) </span>
      }
      @if (isHelpShown) {
        <span class="help-more" (click)="isHelpShown = false"> ▲ </span>
      }
    </div>
  }

  <div
    #processBody
    class="process-body"
    [class.is-resizing]="isResizing"
    [class.logs-open]="isLogsOpen"
    [style.grid-template-columns]="isLogsOpen ? '1fr 6px ' + logsDrawerWidth + 'px' : null">
    <div class="params-panel">
      <div class="apiz-p-grid blade-grid" [style.--blade-nb-cols]="apizUiProcess()?.process?.nbCol">
        <ng-template iuDynamicContainer />
        @if (isReport && exportDataOptions) {
          @if (hasFormat) {
            <iu-autocomplete-ui
              #printFormatsAutocomplete
              [attr.data-cy]="'exportDataOptions-printFormats'"
              [cssClass]="'p-col-12 p-offset-0'"
              [data]="exportDataOptions.printFormats"
              [isStandalone]="true"
              label="{{ 'exportData.printFormats' | translate }}"
              tooltip="{{ 'exportData.printFormats' | translate }}"
              (fieldValueModified)="onPrintFormatChange($any($event))" />
          }
          <iu-autocomplete-ui
            #fileTypesAutocomplete
            [attr.data-cy]="'exportDataOptions-fileTypes'"
            [cssClass]="'p-col-12 p-offset-0'"
            [data]="exportDataOptions.fileTypes"
            [fieldValue]="defaultFileType"
            [isStandalone]="true"
            label="{{ 'exportData.fileTypes' | translate }}"
            tooltip="{{ 'exportData.fileTypes' | translate }}" />
        }
      </div>
    </div>

    <div
      class="logs-resize-handle"
      [class.active]="isLogsOpen"
      (mousedown)="onResizeStart($event)"
      (touchstart)="onResizeStart($event)"></div>

    <div class="logs-drawer">
      <div class="logs-drawer-inner">
        <div class="logs-drawer-header">
          <span class="logs-drawer-title">{{ 'process.logs' | translate }}</span>
        </div>
        <iu-process-logs-ui #logContainer />
      </div>
    </div>
  </div>

  <div class="process-footer">
    <div class="process-status">
      @let step = steps[activeIndex];
      <span class="status-label">{{ step.label }}</span>
      @if (activeIndex === 1 && processElapsedLabel()) {
        <span class="status-timing">Processus lancé depuis {{ processElapsedLabel() }}</span>
      }
      @if (activeIndex === 2 && processDoneLabel()) {
        <span class="status-timing status-timing--done">Processus terminé à {{ processDoneLabel() }}</span>
      }
    </div>
    <button
      data-cy="process-button"
      icon="fa fa-check"
      pButton
      [attr.data-cy-channelId]="channelId"
      [attr.data-cy-processId]="windowId"
      class="p-button p-button-primary {{ isProcessing ? 'iu-btn-disabled' : '' }}"
      [disabled]="isProcessing"
      label="{{ 'process.execute' | translate }}"
      (click)="prepareExecuteProcess($event)"></button>
  </div>
</div>

<div [ngClass]="[!displayFormUI ? 'hidden' : '', 'specificModal']">
  <iu-modal-ui
    #specificModal
    [angularStyle]="customFormModalBodyCss"
    [isModalDisplay]="displayFormUI"
    [title]="specificWindowTitle"
    (closeModalEmitter)="updateModalDisplay({ display: { key: 'displayFormUI', value: false } })">
    <ng-template #vcrSpecific />
  </iu-modal-ui>
</div>
